import {
  SET_CHAT_INTERVAL,
  REQUEST_APPEAL_SUCCESS,
  RECEIVE_EXAM_DATA
} from '../constants';

const timeSlotChat = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_APPEAL_SUCCESS:
      return {
        ...state,
        text: '',
        value: null
      };
    case RECEIVE_EXAM_DATA:
      if (!action.payload.saveApprove) {
        return {
          ...state,
          text: '',
          value: null
        };
      }

      return state;
    case SET_CHAT_INTERVAL:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default timeSlotChat;
